import { CheckCircleFilled } from "@ant-design/icons";
import { UserBubbleLinkText } from "@shared/ui";
import "./journals-amendments-signed-by-cell.scss";

interface JournalsAmendmentsSignedByCellProps {
  name: string;
  verified?: boolean;
}

export const JournalsAmendmentsSignedByCell = ({
  name,
  verified,
}: JournalsAmendmentsSignedByCellProps) => {
  return (
    <div className="journals-amendments-signed-by-cell">
      {name === "—" ? (
        <span>{name}</span>
      ) : (
        <UserBubbleLinkText>{name}</UserBubbleLinkText>
      )}
      {verified ? (
        <CheckCircleFilled
          className="journals-amendments-signed-by-cell__icon"
          aria-label="Подписано"
        />
      ) : null}
    </div>
  );
};
